import React, { useMemo, useState } from "react";
//MUI components
import { Card, Grid } from "@mui/material";

//AJCE components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import SearchDataTable from "./SearchDataTable";
import FilterSection from "./FilterSection";
import MDSnackbar from "components/MDSnackbar";
import formatStudentData from "../data/formatStudentsData";
import { useMaterialUIController } from "context";

const Search = () => {
  const countPerFetch = 15;
  const [result, setResult] = useState([]);
  const [searchedFilter, setSearchedFilter] = useState(null);
  const [lastDocSnapshot, setLastDocSnapshot] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    description: "",
    type: "error",
    icon: "error",
  });

  const [MUIController] = useMaterialUIController();

  const table = useMemo(
    () => formatStudentData(result, MUIController.sidenavColor),
    [result, MUIController.sidenavColor]
  );

  function closeSnackbar() {
    setSnackbar((prev) => {
      prev.description = "";
      return { ...prev };
    });
  }

  return (
    <>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor={MUIController.sidenavColor}
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Advanced Search
              </MDTypography>
            </MDBox>
            <MDBox pt={3}>
              <FilterSection
                countPerFetch={countPerFetch}
                loadingState={[isLoading, setIsLoading]}
                resultState={[result, setResult]}
                searchedFilterState={[searchedFilter, setSearchedFilter]}
                setLastDocSnapshot={setLastDocSnapshot}
                setSnackbar={setSnackbar}
              />
              <SearchDataTable
                countPerFetch={countPerFetch}
                table={table}
                isSorted={true}
                entriesPerPage={false}
                showTotalEntries={false}
                loadingState={[isLoading, setIsLoading]}
                searchedFilter={searchedFilter}
                lastDocSnapshotState={[lastDocSnapshot, setLastDocSnapshot]}
                setResult={setResult}
                setSnackbar={setSnackbar}
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
      <MDSnackbar
        color={snackbar.type}
        icon={snackbar.icon}
        title="AJCE Hostel Management"
        dateTime=""
        content={snackbar.description}
        open={!!snackbar.description}
        onClose={closeSnackbar}
        close={closeSnackbar}
        bgWhite
      />
    </>
  );
};

export default Search;
